import { combineReducers } from 'redux';
import apiRequestsReducer from './apiRequestsReducer';
import errorReducer from './errorReducer';
import loadReducer from './loadReducer';
import logMessageReducer from './logMessageReducer';
import loginReducer from './loginReducer';
import restaurantActiveReducer from './restaurantActiveReducer';
import restaurantReducer from './restaurantReducer';
import restaurantsReducer from './restaurantsReducer';
import ssoCredsReducer from './ssoCredsReducer';
// import storage from "redux-persist/lib/storage";

export const reducers = {
  apiRequests: apiRequestsReducer,
  error: errorReducer,
  loading: loadReducer,
  logMessage: logMessageReducer,
  restaurant: restaurantReducer,
  restaurantActive: restaurantActiveReducer,
  restaurants: restaurantsReducer,
  ssoCreds: ssoCredsReducer,
  user: loginReducer,
};

// App's top-level reducers
const appReducer = combineReducers(reducers);

const rootReducer = (state, action) => {
  // Clear majority of the Redux state for when switching between venues with staff login
  if (action.type === 'SET_ACTIVE_RESTAURANT') {
    const { restaurant, restaurantActive, user } = state;

    // eslint-disable-next-line no-param-reassign
    state = { restaurant, restaurantActive, user };
  }
  return appReducer(state, action);
};

export default rootReducer;
